import {
  PORTFOLIO_WALLETS_GET,
  WALLETS_TRANSACTIONS_GET,
  WALLETS_WITH_TRANSACTIONS_GET,
} from '../actions/types';

const initialState = {
  items: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PORTFOLIO_WALLETS_GET._SUCCESS: {
      const { portfolioId, wallets } = action.payload;
      state.items[portfolioId] = wallets;
      return state;
    }
    case WALLETS_TRANSACTIONS_GET._SUCCESS: {
      const { portfolioId, walletId, transactions } = action.payload;
      state.items[portfolioId].find((w) => w.id === walletId).transactions = transactions;
      return state;
    }
    case WALLETS_WITH_TRANSACTIONS_GET._SUCCESS: {
      const { portfolioId, wallets } = action.payload;
      state.items[portfolioId] = wallets;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as wallets };
